import { render } from "./TeItiKahurangiDashboard.vue?vue&type=template&id=3e6fe136&scoped=true"
import script from "./TeItiKahurangiDashboard.vue?vue&type=script&lang=js"
export * from "./TeItiKahurangiDashboard.vue?vue&type=script&lang=js"

import "./TeItiKahurangiDashboard.vue?vue&type=style&index=0&id=3e6fe136&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6fe136"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QIcon,QTooltip,QSpinner,QBtn});
